/**
 * O desenho dos campos de filtro de Lançamentos e da busca de favorecidos.
 *
 * Papel: guarda as classes que a origem escreve por `style` nos filtros
 * (l. 372–417, 487): Outfit 12 px 400 em `--texto-fraco`, `7px 10px`, raio de
 * 6 px e borda bege nos campos da primeira linha e na busca; `4px 7px` e 11 px
 * nos dois campos de data do período; e o rótulo em Outfit 11 px caixa alta
 * com `.5px` que fica em cima de cada filtro.
 *
 * Como usar: as classes vão no `className` de um `<input>` ou `<select>`
 * comum. Os `select` dos filtros ficam com a seta do navegador, como na
 * origem, onde eles não estão dentro de `.filter-bar` e não ganham a seta
 * desenhada; trocar por `appearance-none` mudaria o que a pessoa vê.
 */
import { type ReactNode } from 'react';

/** Os campos da primeira linha de filtros e a busca de favorecidos. */
export const CLASSE_DO_CAMPO_DE_FILTRO =
  'font-outfit border-emb-borda w-full rounded-[6px] border bg-superficie px-2.5 py-[7px] text-[12px] font-normal text-texto-fraco outline-none';

/** Os dois campos de data do período. */
export const CLASSE_DA_DATA_DE_FILTRO =
  'font-outfit border-emb-borda rounded-[6px] border bg-superficie px-[7px] py-1 text-[11px] text-texto-fraco outline-none';

/**
 * O rótulo em cima de um filtro.
 *
 * @param children - O texto, como a origem o escreve; a caixa alta vem do CSS.
 * @param htmlFor - O `id` do campo, para o rótulo nomeá-lo.
 * @returns O `<label>`.
 */
export function RotuloDeFiltro({
  children,
  htmlFor,
}: {
  children: ReactNode;
  htmlFor: string;
}) {
  return (
    <label
      htmlFor={htmlFor}
      className="mb-1 block font-outfit text-[11px] font-normal tracking-[0.5px] text-texto-fraco uppercase"
    >
      {children}
    </label>
  );
}
